var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h4',{attrs:{"id":"loginStatus"}},[_vm._v(_vm._s(_vm.loginStatus))]),_c('div',{attrs:{"id":"formsContainer"}},[_c('login-form'),_c('sign-up-form')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }